import { render, staticRenderFns } from "./BlockOptionCards.vue?vue&type=template&id=12e8c95c"
import script from "./BlockOptionCards.vue?vue&type=script&lang=js"
export * from "./BlockOptionCards.vue?vue&type=script&lang=js"
import style0 from "./BlockOptionCards.vue?vue&type=style&index=0&id=12e8c95c&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports